import { render, staticRenderFns } from "./Viatic.vue?vue&type=template&id=1e334b19"
import script from "./Viatic.vue?vue&type=script&lang=js"
export * from "./Viatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports